import { createFileRoute } from "@tanstack/react-router";
import { UsuariosPage } from "@/pages/UsuariosPage";

export const Route = createFileRoute("/usuarios/")({
  head: () => ({
    meta: [
      { title: "Usuários — AXIS Comprovantes" },
      {
        name: "description",
        content: "Gerencie usuários, permissões e acessos do AXIS Comprovantes.",
      },
    ],
  }),
  component: () => <UsuariosPage />,
});
